<template>
  <div class="text-right mt-5">
    <vs-button
      class="mr-3 mb-2"
      @click="$emit('submit')"
    >{{ submitText }}</vs-button>
    <vs-button
      color="warning"
      type="border"
      class="mb-2"
      @click="$emit('cancel')"
    >Cancel</vs-button>
  </div>
</template>

<script>
export default {
  props: {
    submitText: {
      type: String,
      default: 'Submit'
    }
  }
}
</script>
